import { useEffect, useState } from "react";
import { useEsri } from "./EsriContext";
import { ListRow } from "./components/ListRow";
import { OpacitySlider, useOpacity } from "./esri-components/OpacitySlider";
import Checkbox from "./components/Checkbox";
import ReactTooltip from "react-tooltip";
import { HelpTooltipIcon } from "./components/Icons";
import { DEFAULT_OPACITY } from "./settings";

const layerOptions = {
  id: null,
  url: "",
  outFields: ["*"],
  opacity: null,
  returnExtentOnly: true,
  visible: true,
  overwriteActions: true,
};

const OverlayLayerItem = ({ layer, onLayerCheck }) => {
  const [checkboxState, setCheckboxState] = useState(true);
  const { addLayer, setLayerVisible, layerOpacity } = useEsri();
  const {
    opacityBtnStatus,
    opacityLayerValue,
    setOpacityLayerValue,
    setOpacityBtnStatus,
  } = useOpacity({
    DEFAULT_OPACITY: DEFAULT_OPACITY,
  });

  useEffect(() => {
    if (!layer) return;
    const layerOptionsPM = {
      ...layerOptions,
      url: layer.url + "/0",
      id: layer.id,
    };
    addLayer(layerOptionsPM);
    setOpacityBtnStatus(false);
  }, [addLayer, layer, setOpacityBtnStatus]);

  useEffect(() => {
    if (!layer) return;
    if (typeof opacityLayerValue !== "number") return;
    layerOpacity(layer.id, opacityLayerValue);
  }, [opacityLayerValue, layerOpacity, layer]);

  const onOpacityChange = (value) => {
    setOpacityLayerValue(value);
  };

  const onCheckboxChange = () => {
    checkboxState ? setCheckboxState(false) : setCheckboxState(true);
    const layerStatues = checkboxState ? false : true;
    setLayerVisible(layer.id, layerStatues);
    onLayerCheck({
      alias: layer.alias,
      layerState: layerStatues,
    });
  };

  return (
    <ListRow
      actionCheckBox={
        <Checkbox
          checked={checkboxState}
          onChangeCallback={() => {
            onCheckboxChange(layer.id);
          }}
        />
      }
      name={layer.name}
      actionsNode={
        <>
          {layer.tooltip ? (
            <>
              <HelpTooltipIcon tooltipFor={`${layer.alias}_tooltip`} />
              <ReactTooltip
                id={`${layer.alias}_tooltip`}
                place="right"
                effect="solid"
              >
                <span>{layer.tooltip}</span>
              </ReactTooltip>
            </>
          ) : (
            ""
          )}
          <div className="relative mr-2">
            <OpacitySlider
              onChange={onOpacityChange}
              defaultOpacity={opacityLayerValue}
              btnStatus={opacityBtnStatus}
            />
          </div>
        </>
      }
    />
  );
};

export default OverlayLayerItem;
